import React from 'react'
import Layout from '../../Common/Layout/Layout';

const Public = () => {
    return <Layout />
};

export default Public